import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { AdminData, AdminRightData } from '../../_models/admin';
import { CountryData } from '../../_models/country';
import { Counts } from '../../_models/data';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { NotificationService } from '../../_services/notification.service';

@Component({
  selector: 'app-admin-right',
  templateUrl: './admin-right.component.html',
  styleUrl: './admin-right.component.css'
})
export class AdminRightComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;
  
  // userData: UserData;
  page: number = 1;
  count: Counts;

  url = this.router.url.slice(1);

  mainHeader: string = "List All Administrator Rights ";
  formHeader: string = "Add New Right ";
  view: string = "";

  processing: boolean = false;
  loading: boolean = true;
  editingRight: boolean = false;
  buttonText: string = "Add New Right ";

  countryList: CountryData[] = [];
  adminRightList: AdminRightData[] = [];
  allowedPage: string[] = [];

  dataForm = this.fb.group({
    ref: [0],
    title: ["", Validators.required],
    super: [false],
    read: [{value: true, disabled: true}],
    write: [false],
    modify: [false],
    pages: [[] as string[], Validators.required],
    mainPage: ["", Validators.required],
    country: [[] as string[], Validators.required],
    status: ["active"],
  }, {});
  
  get ref() { return this.dataForm.get('ref'); }
  get title() { return this.dataForm.get('title'); }
  get super() { return this.dataForm.get('super'); }
  get read() { return this.dataForm.get('read'); }
  get write() { return this.dataForm.get('write'); }
  get modify() { return this.dataForm.get('modify'); }
  get pages() { return this.dataForm.get('pages'); }
  get mainPage() { return this.dataForm.get('mainPage'); }
  get country() { return this.dataForm.get('country'); }
  get status() { return this.dataForm.get('status'); }

  constructor(
    private fb: FormBuilder,
    public checkService: ChecksService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router,
  ) {
    this.checkService.checkSession();
    this.getRouteParams();
    this.getCountries();
    this.getData();
  }

  ngOnInit(): void {

    if (this.routeParams['view'] !== undefined) {
      this.view = this.routeParams['view'];
      this.mainHeader = "List "+this.view+" Administrator Rights ";
    }

    if (this.queryParams['page'] !== undefined) {
      this.page = this.queryParams['page'];
    } else {
      this.page = 1;
    }
    this.listAdminRight();
    this.applySuperControl();
  }

  listAdminRight() {
    this.loading = true;

    this.apiService.listAdminRight().subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.adminRightList = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );
  }

  getData() {
    this.apiService.getRightData().subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.countryList = data.data.country;
          this.allowedPage = data.data.pages;
        } else {
          this.notifyService.showError("An error occured getting data to build this page", "Error")
        }
      }
    );
  }

  getCountries() {
    this.loading = true;

    this.apiService.getCountries(0, "list").subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.count = data.counts;
          this.countryList = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }

  onCreate() {
    const formValue = this.dataForm.getRawValue();
    var data: object = {
      ref: formValue.ref,
      title: formValue.title,
      super: formValue.super,
      read: formValue.read,
      write: formValue.write,
      modify: formValue.modify,
      pages: formValue.pages,
      mainPage: formValue.mainPage,
      country: formValue.country,
      status: formValue.status || "active"
    };
 
    this.saveRight(data);
  }

  saveRight( data ) {
    this.processing = true;

    this.buttonText = this.editingRight ? "Saving Right ..." : "Adding New Right ...";
    const request = this.editingRight ? this.apiService.modifyRight(data) : this.apiService.createRight(data);
    request.subscribe(
      user => {
        this.checkService.checkLoggedin(user);
        this.processing = false
        if (user.success == true) {
          const actionText = this.editingRight ? "Updated" : "Created";
          this.notifyService.showSuccess(actionText+" "+data.title+" as an Administrator Right ", "Administrator Right "+actionText);
          this.listAdminRight();
          this.cancelEdit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
        this.buttonText = this.editingRight ? "Save Right " : "Add New Right ";
      }
    );
  }

  editRight(right: AdminRightData) {
    this.editingRight = true;
    this.formHeader = "Modify Right ";
    this.buttonText = "Save Right ";
    this.dataForm.patchValue({
      ref: right.ref,
      title: right.adminType,
      super: right.super,
      read: right.read,
      write: right.write,
      modify: right.modify,
      pages: right.pages,
      mainPage: right.mainPage,
      country: right.countryList.map(country => country.iso),
      status: right.status || "active"
    });
    this.applySuperControl();
  }

  cancelEdit() {
    this.editingRight = false;
    this.formHeader = "Add New Right ";
    this.buttonText = "Add New Right ";
    this.dataForm.reset({
      ref: 0,
      title: "",
      super: false,
      read: true,
      write: false,
      modify: false,
      pages: [],
      mainPage: "",
      country: [],
      status: "active"
    });
    this.read?.disable();
    this.applySuperControl();
  }

  changeRightStatus(right: AdminRightData, status: string) {
    const statusText = status === "active" ? "enable" : "disable";
    if (!confirm("Are you sure you want to "+statusText+" "+right.adminType+"?")) {
      return;
    }

    this.processing = true;
    this.apiService.changeRightStatus({ref: right.ref, status}).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.processing = false;
        if (data.success == true) {
          this.notifyService.showSuccess("Administrator right updated", "Success");
          this.listAdminRight();
        } else {
          this.notifyService.showError(data.error.message + ". " + data.error.additional_message, "Error")
        }
      }
    );
  }

  deleteRight(right: AdminRightData) {
    if (!confirm("Are you sure you want to delete "+right.adminType+"?")) {
      return;
    }

    this.processing = true;
    this.apiService.deleteRight(right.ref).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.processing = false;
        if (data.success == true) {
          this.notifyService.showSuccess("Administrator right deleted", "Success");
          this.listAdminRight();
          if (this.ref?.value === right.ref) {
            this.cancelEdit();
          }
        } else {
          this.notifyService.showError(data.error.message + ". " + data.error.additional_message, "Error")
        }
      }
    );
  }

  isRightActive(right: AdminRightData) {
    return (right.status || "active") === "active";
  }

  private applySuperControl() {
    let adminData:AdminData = this.checkService.getAdminData();
    if (!adminData.rights.super) {
      this.super?.disable();
    } else {
      this.super?.enable();
    }
  }
  
  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }
}
